import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
//import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import rtl from "jss-rtl";
import { useEffect } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { history } from '../helpers/history';
import { authActions } from '../helpers/store';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import image from "../images/main.jpg"; 
import signin from '../assets/images/signin.jpg'
import { useState } from "react";
import ErrorIcon from '@mui/icons-material/Error';
import logo from '../assets/images/logo.png'
// react-router-dom components
import { Link } from "react-router-dom";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// @mui material components
import Switch from "@mui/material/Switch";

// Argon Dashboard 2 MUI components
import ArgonBox from "../components/dashdata/ArgonBox";
import ArgonTypography from "../components/dashdata/ArgonTypography";
import ArgonInput from "../components/dashdata/ArgonInput";
import ArgonButton from "../components/dashdata/ArgonButton";

// Authentication layout components
import IllustrationLayout from "../components/dashdata/IllustrationLayout/index";

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="#">
        پورتال مشتریان  
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const mdTheme = createTheme({
  typography: {
    fontFamily: [
      "mohammadfont",
      "Tahoma",
      "Verdana"
    ].join(",")
  },
  direction: "rtl"
});

// Image
const bgImage = signin;//"/assets/images/signin-ill.jpg";

export const Login = () => {

  const [open, setOpen] = React.useState(false);//false یعنی موقع اجرا پیامی نیاد

  const dispatch = useDispatch();
  const authUser = useSelector(x => x.auth.user);
  const authError = useSelector(x => x.auth.error);
  const pageData = useSelector(x => x.page);

  useEffect(() => {
      // redirect to home if already logged in
      if (authUser) history.navigate('/');

      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

const handleSubmit = (event) => {
  event.preventDefault();
  const data = new FormData(event.currentTarget);
  console.log({
    username: data.get('username'),
    password: data.get('password'),
  });
  const dataToSend = {
    username: data.get('username'),
    password: data.get('password'),
  };
  return dispatch(authActions.login(dataToSend));
};


  const [rememberMe, setRememberMe] = useState(false);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const theme = createTheme({
    raisedButton: {
      textColor: '#ffffff', // this should work
      primaryTextColor: '#ffffff' // or this if using `primary` style
    }
  });
  return (
    
    <IllustrationLayout
      title="ورود به سیستم"
      description="با نام کاربری و رمز عبور وارد شوید"
      illustration={{
        image: bgImage,
        title: '"سامانه پورتال مشتریان"',
        description:
          "با استفاده از این پورتال وارد سیستم شده و از امکانات آن بهره مند شوید",
      }}
    >
       <ThemeProvider theme={mdTheme}>
        <Box 
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <img src={logo} />
          <Typography component="h1" variant="h5">
            ورود به سیستم
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="نام کاربری"
              name="username"
              autoComplete="username"
              autoFocus
            
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="گذرواژه"
              type="password"
              id="password"
              autoComplete="current-password"
           
            />
         {pageData.isLoading ? ( 
        <Backdrop 
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop> ) : (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 3, mb: 2 }}
            >
              ورود
            </Button>
                 )}
            <Grid container>
              <Grid item xs>
                {authError &&
                <Typography component="div" sx={{ color: "#E53935" }}>
                <ErrorIcon sx={{ color: "#E53935" }} /> &nbsp; {authError.message}
                </Typography>    
                }
              </Grid>
            </Grid>
          </Box>
        </Box>
        {
        <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">
          {"اطلاعیه"}
        </DialogTitle>
        <DialogContent>
        
         <span style={{textAlign : 'justify'}}>
          با سلام.
          لیست قیمت جدید عادل لنز از 9 اردیبهشت قابل اجرا می باشد
         </span>
         
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            متوجه شدم
          </Button>
        </DialogActions>
      </Dialog>
       }
        </ThemeProvider>
    </IllustrationLayout>
  );
}

export default Login;
